import { render, staticRenderFns } from "./TableOccupied.vue?vue&type=template&id=52867b54"
import script from "./TableOccupied.vue?vue&type=script&lang=js"
export * from "./TableOccupied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports